import React, { useContext, useEffect, useState } from 'react';
import { 
  View, 
  Text, 
  FlatList, 
  StyleSheet, 
  TextInput,
  RefreshControl,
  Alert
} from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { Button, IconButton } from 'react-native-paper';
import { RefreshContext } from '../../../App';  // Ajuste o caminho conforme necessário
import { supabase } from '../../services/supabase'; // Importe o supabase

console.log('ARQUIVO ListaClientesScreen.tsx CARREGADO');

const ListaClientesScreen = () => {
  console.log('LISTA DE CLIENTES SCREEN RENDERIZADA');
  
  const navigation = useNavigation();
  const { refreshKey } = useContext(RefreshContext);
  const [filtro, setFiltro] = useState('');
  const [clientes, setClientes] = useState([]);
  const [isRefreshing, setIsRefreshing] = useState(false);

  const fetchClientes = async () => {
    try {
      console.log('Iniciando fetchClientes...');
      setIsRefreshing(true);
      
      // Primeiro busca o usuário logado
      const { data: { user } } = await supabase.auth.getUser();
      console.log('Usuário autenticado:', user?.id);
      if (!user) throw new Error('Usuário não autenticado');

      // Busca o codempresa do usuário
      const { data: userData, error: userError } = await supabase
        .from('usuarios')
        .select('empresa')
        .eq('id', user.id)
        .single();

      if (userError) throw userError;
      if (!userData?.empresa) throw new Error('Empresa não encontrada');

      console.log('Preparando chamada para lista de clientes...');
      // Primeira chamada para lista de clientes usando a instância do Supabase configurada
      const { data: responseClientesData, error: responseClientesError } = await supabase.rpc(
        'http_obter_json_api_async',
        {
          caminhoapi: 'FINANCEIROListaClienteDeb',
          functionproxima: 'listasconsultaapi',
          idempresa: userData.empresa,
          rotaapi: 'FINANCEIROListaClienteDeb'
        }
      );
      
      if (responseClientesError) {
        console.error('Erro ao buscar lista de clientes:', responseClientesError);
        throw new Error(`Erro ao buscar lista de clientes: ${responseClientesError.message}`);
      }
      
      // Simulando a resposta do fetch para manter compatibilidade com o código existente
      const responseClientes = {
        ok: true,
        json: async () => responseClientesData
      };
      console.log('Resposta clientes recebida');

      console.log('Preparando chamada para lista de títulos...');
      // Segunda chamada para lista de títulos usando a instância do Supabase configurada
      const { data: responseTitulosData, error: responseTitulosError } = await supabase.rpc(
        'http_obter_json_api_async',
        {
          caminhoapi: 'FINANCEIROListaTituloDeb',
          functionproxima: 'listasconsultaapi',
          idempresa: userData.empresa,
          rotaapi: 'FINANCEIROListaTituloDeb'
        }
      );
      
      if (responseTitulosError) {
        console.error('Erro ao buscar lista de títulos:', responseTitulosError);
        throw new Error(`Erro ao buscar lista de títulos: ${responseTitulosError.message}`);
      }
      
      // Simulando a resposta do fetch para manter compatibilidade com o código existente
      const responseTitulos = {
        ok: true,
        json: async () => responseTitulosData
      };
      console.log('Resposta títulos recebida');

      // Verificar respostas
      if (!responseClientes.ok || !responseTitulos.ok) {
        console.error('Erro nas requisições:', {
          clientesStatus: responseClientes.status,
          titulosStatus: responseTitulos.status
        });
        throw new Error('Erro ao atualizar dados');
      }

      // Buscar dados atualizados de clientes do Supabase
      const { data, error } = await supabase
        .from('listasconsultaapi')
        .select('data')
        .eq('rotaapi', 'FINANCEIROListaClienteDeb')
        .eq('codempresa', userData.empresa)
        .order('created_at', { ascending: false })
        .limit(1);

      console.log('Dados da consulta Supabase:', data);

      // Chamada da função para o mesmo endpoint usando a instância do Supabase configurada
      console.log('Iniciando chamada da função FINANCEIROListaClienteDeb...');
      const { data: responseFuncaoData, error: responseFuncaoError } = await supabase.rpc(
        'http_obter_json_api_async',
        {
          caminhoapi: 'FINANCEIROListaClienteDeb',
          functionproxima: 'listasconsultaapi',
          idempresa: userData.empresa,
          rotaapi: 'FINANCEIROListaClienteDeb'
        }
      );
      
      if (responseFuncaoError) {
        console.error('Erro na chamada da função:', responseFuncaoError);
        throw new Error(`Erro na chamada da função: ${responseFuncaoError.message}`);
      }
      
      console.log('Resposta função recebida');
      const funcaoData = responseFuncaoData;
      console.log('Dados da função:', funcaoData);

      if (error) throw error;

      if (data && data[0]?.data) {
        const clientesArray = Array.isArray(data[0].data) ? data[0].data : [];
        console.log('Quantidade de clientes:', clientesArray.length);
        setClientes(clientesArray.map(cliente => ({
          id: cliente.I_CODCLI,
          razao: cliente.S_CLIENTE,
          cnpj: cliente.S_CGCENT,
          pontualidade: cliente.F_PONTUALIDADE || 0,
          qtdTitulos: cliente.I_QTDETITULOS || 0
        })));
      }
    } catch (error) {
      console.error('Erro completo ao buscar clientes:', error);
      // Opcional: mostrar mensagem de erro para o usuário
    } finally {
      setIsRefreshing(false);
    }
  };

  const atualizarDadosAPI = async () => {
    try {
      console.log('Iniciando atualização dos dados...');
      setIsRefreshing(true);
      
      // Primeiro busca o usuário logado
      const { data: { user } } = await supabase.auth.getUser();
      console.log('Usuário autenticado:', user?.id);
      if (!user) throw new Error('Usuário não autenticado');

      // Busca o codempresa do usuário
      const { data: userData, error: userError } = await supabase
        .from('usuarios')
        .select('empresa')
        .eq('id', user.id)
        .single();

      if (userError) throw userError;
      if (!userData?.empresa) throw new Error('Empresa não encontrada');

      // Usando a chave do .env ao invés da hardcoded
      // Chamada para atualizar dados dos clientes usando a instância do Supabase configurada
      console.log('Atualizando dados dos clientes...');
      const { data: responseClientesData, error: responseClientesError } = await supabase.rpc(
        'http_obter_json_api_async',
        {
          caminhoapi: 'FINANCEIROListaClienteDeb',
          functionproxima: 'listasconsultaapi',
          idempresa: userData.empresa,
          rotaapi: 'FINANCEIROListaClienteDeb'
        }
      );
      
      if (responseClientesError) {
        console.error('Erro ao atualizar dados dos clientes:', responseClientesError);
        throw new Error(`Erro ao atualizar dados dos clientes: ${responseClientesError.message}`);
      }
      
      // Simulando a resposta do fetch para manter compatibilidade com o código existente
      const responseClientes = {
        ok: true,
        json: async () => responseClientesData
      };

      // Chamada para atualizar dados dos títulos usando a instância do Supabase configurada
      console.log('Atualizando dados dos títulos...');
      const { data: responseTitulosData, error: responseTitulosError } = await supabase.rpc(
        'http_obter_json_api_async',
        {
          caminhoapi: 'FINANCEIROListaTituloDeb',
          functionproxima: 'listasconsultaapi',
          idempresa: userData.empresa,
          rotaapi: 'FINANCEIROListaTituloDeb'
        }
      );
      
      if (responseTitulosError) {
        console.error('Erro ao atualizar dados dos títulos:', responseTitulosError);
        throw new Error(`Erro ao atualizar dados dos títulos: ${responseTitulosError.message}`);
      }
      
      // Simulando a resposta do fetch para manter compatibilidade com o código existente
      const responseTitulos = {
        ok: true,
        json: async () => responseTitulosData
      };

      if (!responseClientes.ok || !responseTitulos.ok) {
        throw new Error('Erro ao atualizar dados');
      }

      // Após atualizar os dados, busca os clientes novamente
      await fetchClientes();
      
      Alert.alert('Sucesso', 'Dados atualizados com sucesso!');
    } catch (error) {
      console.error('Erro ao atualizar dados:', error);
      Alert.alert('Erro', 'Não foi possível atualizar os dados. Tente novamente.');
    } finally {
      setIsRefreshing(false);
    }
  };

  useEffect(() => {
    console.log('ListaClientesScreen - useEffect chamado');
    console.log('Iniciando scripts de atualização automaticamente');
    
    const carregarDadosIniciais = async () => {
      try {
        // Primeiro busca o usuário logado
        const { data: { user }, error: authError } = await supabase.auth.getUser();
        
        if (authError) {
          console.error('Erro de autenticação:', authError);
          return;
        }

        if (!user) {
          console.error('Usuário não autenticado');
          return;
        }

        // Busca o codempresa do usuário
        const { data: userData, error: userError } = await supabase
          .from('usuarios')
          .select('empresa')
          .eq('id', user.id)
          .single();

        if (userError) {
          console.error('Erro ao buscar empresa:', userError);
          return;
        }

        if (!userData?.empresa) {
          console.error('Empresa não encontrada');
          return;
        }

        // Usando a chave do .env ao invés da hardcoded
        const apiKey = process.env.SUPABASE_ANON_KEY;
        if (!apiKey) throw new Error('API Key não encontrada');
        const supabaseUrl = process.env.SUPABASE_URL;
        if (!supabaseUrl) throw new Error('URL do Supabase não encontrada');

        // Primeira chamada para lista de clientes usando a instância do Supabase configurada
        console.log('Iniciando chamada para lista de clientes...');
        const { data: responseClientesData, error: responseClientesError } = await supabase.rpc(
          'http_obter_json_api_async',
          {
            caminhoapi: 'FINANCEIROListaClienteDeb',
            functionproxima: 'listasconsultaapi',
            idempresa: userData.empresa,
            rotaapi: 'FINANCEIROListaClienteDeb'
          }
        );
        
        if (responseClientesError) {
          console.error('Erro ao buscar lista de clientes:', responseClientesError);
          throw new Error(`Erro ao buscar lista de clientes: ${responseClientesError.message}`);
        }
        
        console.log('Resposta clientes recebida');
        const clientesData = responseClientesData;
        console.log('Dados clientes:', clientesData);

        // Segunda chamada para lista de títulos usando a instância do Supabase configurada
        console.log('Iniciando chamada para lista de títulos...');
        const { data: responseTitulosData, error: responseTitulosError } = await supabase.rpc(
          'http_obter_json_api_async',
          {
            caminhoapi: 'FINANCEIROListaTituloDeb',
            functionproxima: 'listasconsultaapi',
            idempresa: userData.empresa,
            rotaapi: 'FINANCEIROListaTituloDeb'
          }
        );
        
        if (responseTitulosError) {
          console.error('Erro ao buscar lista de títulos:', responseTitulosError);
          throw new Error(`Erro ao buscar lista de títulos: ${responseTitulosError.message}`);
        }
        
        // Simulando a resposta do fetch para manter compatibilidade com o código existente
        const responseTitulos = {
          ok: true,
          json: async () => responseTitulosData
        };
        console.log('Resposta títulos recebida');
        const titulosData = await responseTitulos.json();
        console.log('Dados títulos:', titulosData);

      } catch (error) {
        console.error('Erro ao carregar dados iniciais:', error);
      }
    };

    carregarDadosIniciais();
    fetchClientes();
  }, [refreshKey]);

  console.log('RENDERIZANDO ListaClientesScreen');

  const clientesFiltrados = clientes.filter(cliente => 
    cliente.razao.toLowerCase().includes(filtro.toLowerCase()) ||
    cliente.cnpj.includes(filtro)
  );

  const renderItem = ({ item }) => (
    <TouchableOpacity 
      style={styles.itemContainer}
      onPress={() => navigation.navigate('DetalheCliente', { clienteId: item.id })}
    >
      <Text style={styles.razao}>{item.razao}</Text>
      <Text>CNPJ: {item.cnpj}</Text>
      <View style={styles.detalhesContainer}>
        <Text>Pontualidade: {item.pontualidade}%</Text>
        <Text>Títulos: {item.qtdTitulos}</Text>
      </View>
    </TouchableOpacity>
  );

  return (
    <View style={styles.container}>
      <TextInput
        style={styles.searchInput}
        placeholder="Buscar cliente"
        value={filtro}
        onChangeText={setFiltro}
      />
      <IconButton
        icon="refresh"
        mode="contained"
        onPress={() => {
          console.error('🚨 DEBUG: Botão pressionado');
          Alert.alert('Debug', 'Botão pressionado');
          const now = new Date().toISOString();
          console.error('🚨 DEBUG: Hora do clique:', now);
          atualizarDadosAPI();
        }}
        style={styles.atualizarButton}
      />
      <FlatList
        data={clientesFiltrados}
        renderItem={renderItem}
        keyExtractor={item => item.id.toString()}
        refreshControl={
          <RefreshControl
            refreshing={isRefreshing}
            onRefresh={fetchClientes}
            colors={['#1a1a1a']}
            tintColor="#1a1a1a"
          />
        }
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f4f4f4'
  },
  searchInput: {
    margin: 10,
    padding: 15,
    backgroundColor: 'white',
    borderRadius: 10
  },
  itemContainer: {
    backgroundColor: 'white',
    margin: 10,
    padding: 15,
    borderRadius: 10
  },
  razao: {
    fontSize: 16,
    fontWeight: 'bold'
  },
  detalhesContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 10
  },
  atualizarButton: {
    backgroundColor: '#4CAF50',
    padding: 10,
    borderRadius: 5,
    margin: 10
  }
});

export default ListaClientesScreen;
